import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const StepContext = createContext({ current: null, total: null });

export const QuestionnaireStepProvider = ({ steps, children }) => {
  const location = useLocation();
  const value = useMemo(() => {
    if (!Array.isArray(steps) || steps.length === 0) {
      return { current: null, total: null };
    }
    const lastSegment = location.pathname.split('/').filter(Boolean).pop();
    const index = steps.indexOf(lastSegment);
    if (index < 0) return { current: null, total: steps.length };
    return { current: index + 1, total: steps.length };
  }, [location.pathname, steps]);
  return <StepContext.Provider value={value}>{children}</StepContext.Provider>;
};

export const useQuestionnaireStep = () => useContext(StepContext);
